<kendo-grid [kendoGridBinding]="gridData"  [pageable]="true"
[pageSize]="10">
      <!-- mobile view -->
      <kendo-grid-column [title]="'substitute.grid.title' | i18n" media="(max-width: 571px)">
        <ng-template kendoGridCellTemplate let-x>
          <div class="d-flex flex-row justify-content-between ">
            <div class="d-flex flex-column flex-1" >
              <div class="d-flex flex-row align-center">
                <span>{{'substitute.grid.user.title' | i18n}}:       <circ-person-from-login [userId]="x.userId"></circ-person-from-login></span>
              </div>
              <div class="d-flex flex-row align-center">
                <span>{{'substitute.grid.deputy.title' | i18n}}:       <circ-person-from-login [userId]="x.deputyId"></circ-person-from-login></span>
              </div>
              <div class="d-flex flex-row align-center">
                <span>{{'substitute.grid.startDate.title' | i18n}}: {{ x.startDate | i18nDate: { date: "medium" } }}</span>
              </div>
              <div class="d-flex flex-row align-center">
                <span>{{'substitute.grid.endDate.title' | i18n}}: {{ x.endDate | i18nDate: { date: "medium" } }}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>

     <!-- desktop view -->
      <kendo-grid-column media="(min-width: 571px)"
      field="userId"
      [title]="'substitute.grid.user.title' | i18n"
    >
    <ng-template kendoGridCellTemplate let-x>
      <circ-person-from-login [userId]="x.userId"></circ-person-from-login>
    </ng-template>
    </kendo-grid-column>
    <kendo-grid-column media="(min-width: 571px)"
      field="deputyId"
      [title]="'substitute.grid.deputy.title' | i18n"
    >
    <ng-template kendoGridCellTemplate let-x>
      <circ-person-from-login [userId]="x.deputyId"></circ-person-from-login>
    </ng-template>
    </kendo-grid-column>
    <kendo-grid-column media="(min-width: 571px)"
      field="startDate"
      [title]="'substitute.grid.startDate.title' | i18n"
    >
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.startDate | i18nDate: { date: "medium" } }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column media="(min-width: 571px)"
      field="endDate"
      [title]="'substitute.grid.endDate.title' | i18n"
    >
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.endDate | i18nDate: { date: "medium" } }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column>
      <ng-template kendoGridCellTemplate let-x>
        <ece-btn-edit
        class="mobile-button px-3"
        [title]="'substitute.grid.functions.edit' | i18n"
        (click)="onEdit(x)"></ece-btn-edit>
        <ece-btn-delete
        class="mobile-button px-3"
        [title]="'substitute.grid.functions.delete' | i18n"
        (click)="onDelete(x)"></ece-btn-delete>
      </ng-template>
    </kendo-grid-column>
      <kendo-grid-messages [noRecords]="'kendo_noRecords' | i18n">
      </kendo-grid-messages>

</kendo-grid>
